import { OffersStatus } from "./enums";

export const OFFERS_STATUSES_LIST = [
  {
    label: "Active",
    value: OffersStatus.Active,
    backgroundColor: "#16C350"
  },
  {
    label: "Inactive",
    value: OffersStatus.Inactive,
    backgroundColor: "#A8A8BB"
  }
];
